import { render, staticRenderFns } from "./BazaDai.vue?vue&type=template&id=6a2a8666&"
import script from "./BazaDai.vue?vue&type=script&lang=js&"
export * from "./BazaDai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports